import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class MobileContactService {
  query

  constructor(query) {
    this.query = query
  }

  getMobileContacts() {
    return RetailerApiClient.get('mobile-contacts', {
      params: this.query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getMobileContact(id) {
    return RetailerApiClient.get('mobile-contacts/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updateMobileContact(id, data) {
    return RetailerApiClient.patch('mobile-contacts/' + id, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
